// extracted by mini-css-extract-plugin
export default {"container":"RootLayout_container__TXnUS","homePage":"RootLayout_homePage__1ERVK","quizPage":"RootLayout_quizPage__nzr-v"};